<template>
	<div class="content text-white">
		<div class="text-3.5xl">
			Settings
		</div>

		<div class="mb-5">
			<SettingsNav />
		</div>

		<!-- <ul class="nav nav-pills nav-pills-primary justify-content-center" role="tablist">

			<li v-if="showKelolaRekening" class="nav-item">
				<a class="nav-link active" data-toggle="tab" href="#nav1-kelola-rekening" role="tablist" aria-expanded="true">
					KELOLA REKENING
				</a>
			</li>

			<li class="nav-item">
				<a :class="`nav-link ${!showKelolaRekening ? 'active' : ''}`" data-toggle="tab" href="#nav1-link1"
					role="tablist" :aria-expanded="!showKelolaRekening ? true : false">
					TRADING
				</a>
			</li>

			<li class="nav-item">
				<a class="nav-link" data-toggle="tab" href="#nav1-link2" role="tablist" aria-expanded="false">
					ACCOUNT
				</a>
			</li>

			<li class="nav-item">
				<a class="nav-link" data-toggle="tab" href="#nav1-link3" role="tablist" aria-expanded="false">
					PAYMENT
				</a>
			</li>

			<li class="nav-item">
				<a class="nav-link" data-toggle="tab" href="#nav1-link6" role="tablist" aria-expanded="false">
					PASSWORD
				</a>
			</li>
		</ul> -->

		<div class="">

			<!-- Rekening Penarikan -->
			<div v-show="tabActive == 'rekening'" >
				<RekeningPenarikan></RekeningPenarikan>
			</div>

			<!-- Profil -->
			<div v-show="tabActive == 'profil'" >
				<SettingProfil></SettingProfil>
			</div>

			<!-- Kepemilikan -->
			<div v-show="tabActive == 'kepemilikan'" >
				<SettingKepemilikan></SettingKepemilikan>
			</div>

			<!-- Password -->
			<div v-show="tabActive == 'password'" >
				<SettingPassword></SettingPassword>
			</div>

		</div>
	</div>
</template>

<script>
import axios from '@/api/axios.js'
import Swal from 'sweetalert2'

import RekeningPenarikan from './settings/RekeningPenarikan.vue'
import SettingProfil from './settings/components/SettingProfil.vue'
import SettingKepemilikan from './settings/components/SettingKepemilikan.vue'
import SettingPassword from './settings/components/SettingPassword.vue'

import SettingsNav from './settings/components/SettingsNav.vue'

export default {
	name: 'Settings',

	components: {
		RekeningPenarikan,
		SettingsNav,

		SettingProfil,
		SettingKepemilikan,
		SettingPassword
	},

	data() {
		return {
			publicPath: process.env.BASE_URL,
			environment: process.env.NODE_ENV,

			hin: this.$store.getters.getHin,
			certifications: [
				{ country: 'DUBAI', total: '25.00' },
				{ country: 'HONG KONG', total: '25.00' },
				{ country: 'LONDON', total: '12.00' },
				{ country: 'NEW YORK', total: '25.00' },
				{ country: 'SINGAPORE', total: '12.00' },
				{ country: 'SYDNEY', total: '12.00' },
				{ country: 'ZURICH', total: '25.00' }
			],
			cancellations: [
				{ country: 'DUBAI', total: '15.00' },
				{ country: 'HONG KONG', total: '15.00' },
				{ country: 'LONDON', total: '6.00' },
				{ country: 'NEW YORK', total: '15.00' },
				{ country: 'SINGAPORE', total: '6.00' },
				{ country: 'SYDNEY', total: '6.00' },
				{ country: 'ZURICH', total: '15.00' }
			],
			trading: {
				email: '-',
				firstName: '-',
				lastName: '-',
				username: '-',
			},
			account: {
				businessName: '-',
				firstName: '-',
				lastName: '-',
				email: '-',
				phoneNumber: '-',
				street: '-',
				city: '-',
				province: '-',
				postcode: '-',
				country: '-'
			},

			// Change password
			oldPassword: '',
			newPassword: '',
			retypeNewPassword: '',
			displayNewPasswordError: 'none',
			displayRetypeNewPasswordError: 'none',

			paymentInfo: null,
			utilityAccountIndex: 0,

			institution: 'Artha Graha',
			institutionLogo: `${process.env.BASE_URL}assets/img/logo-bagi-removebg.png`,
			institutionIsOpen: false,

			passwordRegex: /^(?=.*\d)(?=.*[a-z])(?=.*[a-zA-Z]).{8,}$/,
		}
	},
	computed: {
		tabActive() {
			return this.$store.state.settingToShow
		},

		tradingType() {
			return this.$store.state.tradingType
		},
		utilityBankName: {
			get: function () {
				return this.utilityAccountIndex
			},
			set: function (val) {
				this.utilityAccountIndex == val
			}
		},

		showKelolaRekening() {
			if (this.environment == 'production' || this.$store.getters.getAppName.toLowerCase() == 'pospaygold') {
				return false
			}
			else {
				return true
			}
		}
	},

	created() {
		// axios({
		// 	method: 'get',
		// 	url: '/v2/abx/trading_information'
		// }).then(response => {
		// 	let trading = response.data.data
		// 	this.trading.email = trading.email
		// 	this.trading.firstName = trading.firstName
		// 	this.trading.lastName = trading.lastName
		// 	this.trading.username = trading.username
		// }).catch(error => {
		// 	if (error.response) {
		// 		/*
		// 		 * The request was made and the server responded with a
		// 		 * status code that falls out of the range of 2xx
		// 		 */
		// 	} else if (error.request) {
		// 		/*
		// 		 * The request was made but no response was received, `error.request`
		// 		 * is an instance of XMLHttpRequest in the browser and an instance
		// 		 * of http.ClientRequest in Node.js
		// 		 */
		// 	} else {
		// 		// Something happened in setting up the request and triggered an Error
		// 	}
		// })
		this.setTradingInfo()

		axios.post('/v2/igx/account_information', {
			user_id: this.$store.state.userId
		}).then(response => {
			let account = response.data.data.body
			this.account.businessName = '-'
			this.account.firstName = account.firstName || '-'
			this.account.lastName = account.lastName || '-'
			this.account.email = account.email || '-'
			this.account.phoneNumber = account.phoneNumber || '-'
			this.account.street = account.street || '-'
			this.account.city = account.city || '-'
			this.account.province = account.province || '-'
			this.account.postcode = account.postcode || '-'
			this.account.country = account.country || '-'
		}).catch(error => {
		})

		axios.post('/v2/igx/payment_information', {
			user_id: this.$store.state.userId
		}).then(response => {
			this.paymentInfo = response.data.data.body
		}).catch(error => {
		})

		// axios({
		// 	method: 'get',
		// 	url: '/v2/nasabah/get/referral_code'
		// }).then(response => {
		// 	this.referralCode = response.data.data.body.referral_code
		// }).catch(error => {
		// 	if (error.response) {
		// 		/*
		// 		 * The request was made and the server responded with a
		// 		 * status code that falls out of the range of 2xx
		// 		 */
		// 	} else if (error.request) {
		// 		/*
		// 		 * The request was made but no response was received, `error.request`
		// 		 * is an instance of XMLHttpRequest in the browser and an instance
		// 		 * of http.ClientRequest in Node.js
		// 		 */
		// 	} else {
		// 		// Something happened in setting up the request and triggered an Error
		// 	}
		// })
	},
	mounted() {
	},
	methods: {
		setTradingInfo() {
			const accountInfo = this.$store.state.account

			this.trading = {
				email: accountInfo.email || '-',
				firstName: accountInfo.firstName || '-',
				lastName: accountInfo.lastName || '-',
				username: accountInfo.name || '-',
			}
		},

		changePasswordSubmit() {

			if (!this.passwordRegex.test(this.newPassword)) {
				this.displayNewPasswordError = 'initial'

				Swal.fire({
					background: '#191f31',
					// title: '<span style="color: white;">Pre Order Trading Contract.</span>',
					html: '<span style="color: white;">Password must be at least 8 characters and must contain at least 1 number.</span>'
				})
			}
			else if (this.newPassword != this.retypeNewPassword) {
				this.displayRetypeNewPasswordError = 'initial'
			} else {
				Swal.fire({
					background: '#191f31',
					title: '<span style="color: white;">Are you sure want to change your password?</span>',
					imageWidth: 50,
					imageHeight: 50,
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes'
				}).then(async (result) => {
					if (result.value) {
						const oldPassword = await this.$store.dispatch('sha256', this.oldPassword)
						const newPassword = await this.$store.dispatch('sha256', this.newPassword)

						axios.post('/v2/igx/edit_password', {
							broker_id: this.$store.state.brokerId,
							password: oldPassword,
							new_password: newPassword
						}).then(response => {
							this.oldPassword = ''
							this.newPassword = ''
							this.retypeNewPassword = ''
							Swal.fire({
								background: '#191f31',
								type: 'success',
								title: '<span style="color: white;">Changed!</span>',
								html: '<span style="color: white;">Your password has been changed.</span>'
							})
						}).catch(error => {
							let err = error.response.data

							Swal.fire({
								background: '#191f31',
								type: 'error',
								title: '<span style="color: white;">Failed!</span>',
								html: `<span style="color: white;">${err.data.err_message}</span>`
							})
						})
					}
				})
			}
		},
		

		showWithdrawDestination() {
			this.institutionIsOpen = true
		},
		institutionAfterClose(value) {
			if (value == 'giropos') {
				this.institutionLogo = `${this.publicPath}assets/img/pos-giro.png`
			} else if (value == 'gopay') {
				this.institutionLogo = `${this.publicPath}assets/img/logo-gopay-2.jpg`
			} else if (value == 'ovo') {
				this.institutionLogo = `${this.publicPath}assets/img/logo-ovo-3.jpg`
			} else if (value == 'rekpon' || value == 'cimb') {
				this.institutionLogo = `${this.publicPath}assets/img/logo-cimb-3.png`
			} else if (value == 'linkaja') {
				this.institutionLogo = `${this.publicPath}assets/img/logo-linkaja.png`
			} else if (value == 'dana') {
				this.institutionLogo = `${this.publicPath}assets/img/logo-dana-2.png`
			} else if (value == 'isaku') { //isaku
				this.institutionLogo = `${this.publicPath}assets/img/logo-isaku.jpg`
			} else if (value == 'bca') {
				this.institutionLogo = `${this.publicPath}assets/img/logo-bca-2.png`
			} else if (value == 'mandiri') {
				this.institutionLogo = `${this.publicPath}assets/img/logo-mandiri-3.png`
			} else if (value == 'bni') {
				this.institutionLogo = `${this.publicPath}assets/img/logo-bni-2.png`
			} else if (value == 'Artha Graha') {
				this.institutionLogo = `${this.publicPath}assets/img/logo-bagi-removebg.png`
				this.withdrawDestinationAccountNumber = this.paymentInfo.withdrawal_acc[0].account_number
			}

			if (value != '') {
				this.institution = value
			}

			this.institutionIsOpen = false
		},
	}
}
</script>

<style scoped>
.c-card-body {
	padding: 15px 40px;
}

.c-card-multiple {
	margin: 0px;
}

div.card li {
	padding: 5px 40px;
	padding-top: 10px;
	border: 0px;
	margin: 1px;
	border-radius: 7px;
}

.c-balance {
	background-color: #2e3d61;
	display: inline-block;
	color: white;
}

.vertical-line {
	/*border-left: 2px solid white;*/
	border-right: 1px solid white;
}

@media only screen and (max-width: 768px) {
	.vertical-line {
		/*border-left: 2px solid white;*/
		border-right: 0;
		border-bottom: 1px solid white;
	}
}

.dropdown-menu {
	overflow-y: scroll;
	overflow-x: hidden;
	background-color: #25273A;
	/*color: white;*/
	max-height: 290px;
}

.dropdown-menu:before {
	/*position: static;*/
	display: none;
}

.dropdown-menu .dropdown-item {
	color: white;
}

.dropdown-item-text {
	color: white;
	font-weight: bold;
}
</style>
